import styled from 'styled-components';

export const SectionHeader = styled.div`
    font-size: 14px;
    margin: 30px 0 0;
    width: 100%;
    font-weight: 600;
`;
